import { StepProps } from "~/components/organisms/step";
import { ContactFields } from "../contact-fields";

export function Finance({ control }: { control: StepProps["control"] }) {
  return (
    <>
      <ContactFields
        name="team.finance"
        control={control}
        nameLabel="Finance Name"
        telephoneLabel="Finance Telephone"
        emailLabel="Finance Email"
      />
    </>
  );
}
